module.exports = __webpack_public_path__ + "img/xnxlc-1-sm.9c377753.jpg";